/**
 * @file: reconciliateEntities.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export const reconciliateEntities = <T>(
  existingEntities: T[],
  currentEntities: T[],
  options: {
    // get string representation of a unique key for the given entity
    getKey: (entity: T) => string;
    // diff two entities and return the changes
    diff: (a: T, b: T) => Partial<T>;
  },
) => {
  const { getKey, diff } = options;

  const existingEntitiesMap = new Map(
    existingEntities.map(e => [getKey(e), e]),
  );
  const currentEntitiesMap = new Map(currentEntities.map(e => [getKey(e), e]));
  const entitiesToCreate = currentEntities.filter(
    x => !existingEntitiesMap.has(getKey(x)),
  );
  const entitiesToDelete = existingEntities.filter(
    x => !currentEntitiesMap.has(getKey(x)),
  );
  const entitiesToUpdate: { key: string; changes: Partial<T> }[] = [];
  for (const entity of currentEntities) {
    const key = getKey(entity);
    if (existingEntitiesMap.has(key)) {
      const existingEntity = existingEntitiesMap.get(key)!;
      const changes = diff(existingEntity, entity);
      if (Object.keys(changes).length > 0) {
        entitiesToUpdate.push({
          key,
          changes,
        });
      }
    }
  }

  return {
    entitiesToCreate,
    entitiesToDelete,
    entitiesToUpdate,
  };
};
